'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup(tfa, groups) {
  this.LM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.LL = null;
  this.LM = tfa;
  this.LL = groups;
}
export { $c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup as $c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup };
$p = $c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup;
/** @constructor */
function $h_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup() {
}
export { $h_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup as $h_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup };
$h_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("ConfigureTwoFactorAuthToGroup"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.LM;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LL));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup)) {
    var this$1 = this.LM;
    var b = x$0.LM;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var x = this.LL;
      var x$2 = x$0.LL;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ConfigureTwoFactorAuthToGroup";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.LM;
  }
  if ((n === 1)) {
    return this.LL;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kK)));
}
export { $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup as $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup };
var $d_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup, "presto.types$proto$ConfigureTwoFactorAuthToGroup", ({
  kK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup as $d_Lpresto_types$proto$ConfigureTwoFactorAuthToGroup };
//# sourceMappingURL=presto.types$proto$-Configure-Two-Factor-Auth-To-Group.js.map
